<template>
<!-- 预览单选题/多选题/不定项/判断题/填空题/主观题 -->
    <div class="board">
        <div v-hasPermi="['questionBank:question:info']">
            <div class="title">
                <span><el-button type="text" icon="el-icon-arrow-left" @click="$router.push({path:'/question',query:{id:$route.query.parentId}})">返回</el-button><el-divider direction="vertical"></el-divider><span class="name">{{'预览'+form.type_label}}</span></span>
            </div>
            <div style="height:calc(100% - 83px);overflow:auto">
                <el-form class="left" label-position="right" style="max-width:1000px;margin:auto">
                    <el-form-item label-width="60px">
                        <template slot="label">
                            <el-tag type="info" style="margin-top:4px;font-size:15px">{{form.score}}分</el-tag>
                        </template>
                        <div v-if="form.type == 'fill'" v-html="form.stemPreview" class="ql-editor"></div>
                        <div v-else v-html="form.stem" class="ql-editor"></div>
                    </el-form-item>
                    <div v-if="form.type == 'subjectivity'">
                        <div v-if="form.crosshead.length>0">
                            <el-form-item v-for="(n,l) in form.crosshead" :key="l" :label="'（'+(l+1)+'）'" label-width="100px">
                                <div v-if="n.stem" v-html="n.stem" class="ql-editor"></div>
                            </el-form-item>
                        </div>
                    </div>
                    <el-form-item label-width="60px">
                        <el-tag v-if="form.attachment.stem" size="medium" style="margin-bottom:10px"><a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.stem.file_path,form.attachment.stem.file_name)" target="_blank"><i class="el-icon-download"></i> 附件 {{form.attachment.stem.file_name}}</a></el-tag>
                        <br v-if="form.attachment.stem" />
                        <el-button
                                v-hasPermi="['training:training:list']"
                                v-if="form.training_id"
                                @click="seeShare(form)"
                                type="primary"
                                size="mini"
                                icon="el-icon-monitor">
                            {{ form.training_label }}
                        </el-button>
                    </el-form-item>
                    <el-form-item label-width="60px" label="" v-if="form.type == 'single_choice' || form.type == 'determine'">
                        <el-radio-group v-model="form.choose" v-if="form.type == 'determine'" @change="num+=100" style="line-height:52px">
                            <el-radio label="正确" :key="0+num">正确</el-radio>
                            <el-radio label="错误" :key="1+num">错误</el-radio>
                        </el-radio-group>
                        <el-radio-group v-model="form.choose" v-else>
                            <el-radio v-for="(f,j) in form.choices" :key="j+num" :label="form.type == 'determine' ? f : j" @change="num+=100" style="display:block;line-height:40px;"><i v-if="form.type == 'single_choice'">{{letter[j]}} .&nbsp;&nbsp;</i><span v-html="f" style="display: inline-flex;"></span></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label-width="60px" label="" v-if="form.type == 'choice' || form.type == 'uncertain_choice'">
                        <el-checkbox-group v-model="form.choose" @change="checkboxChange">
                            <el-checkbox v-for="(f,j) in form.choices" :key="j+num" @change="num+=100" :label="j" style="display:block;line-height:40px;"><i>{{letter[j]}} .&nbsp;&nbsp;</i><span v-html="f" style="display: inline-flex;"></span></el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="你的答案：" label-width="142px" v-if="form.type != 'subjectivity'">
                        {{form.type=='single_choice'?letter[form.choose]:(form.type == 'determine'?form.choose:(form.type == 'fill'? '':change(form.choose,form.type)))}}
                        <div v-if="form.type == 'fill'">
                            <el-input v-for="(an,a) in form.answer" :key="a" v-model="text[a]" clearable :placeholder="'请输入填空('+(a+1)+')的答案'" style="margin:0 10px 5px 0;width:200px"></el-input>
                        </div>
                    </el-form-item>
                    <div v-if="form.type === 'subjectivity'">
                        <el-form-item :label="'你的答案：'" label-width="142px" style="margin-top:10px" v-if="form.submit_mode && form.submit_mode.includes('text')">
                            <div v-if="form.crosshead.length>0">
                                <el-form-item :label="'（'+(l+1)+'）'" v-for="(n,l) in form.crosshead" :key="l" label-width="40px" style="margin-bottom:10px !important">
                                    <quill-editor v-model="text[l]" :placeholder="'请输入小题（'+(l+1)+'）的答案'" style="margin-top:-2px"></quill-editor>
                                </el-form-item>
                            </div>
                            <quill-editor v-else v-model="text[0]" placeholder="请输入你的答案" style="margin-top: -2px;"></quill-editor>
                        </el-form-item>
                        <el-form-item :label="'链接地址：'" label-width="142px"  style="margin-top:10px;" v-if="form.submit_mode && form.submit_mode.includes('link')">
                            <el-input  v-model="form.link" clearable :placeholder="'请输入链接地址'"></el-input>
                        </el-form-item>
                        <el-form-item :label="form.submit_mode && form.submit_mode.length == 1 ?'你的答案：':''" label-width="142px" style="margin-top:10px;" v-if="form.submit_mode && form.submit_mode.includes('attachment')">
                            <el-button disabled type="primary" size="mini" icon="el-icon-paperclip">上传答案附件</el-button>
                        </el-form-item>
                    </div>
                    <hr size="1" dashed="dashed" style="border-top:1px #ddd dashed;margin-bottom:24px;margin-top:24px">

                    <el-form-item label="评阅方式：" label-width="114px">
                        <span>{{ reviewModeFormatter(form.review_mode) }}</span>
                    </el-form-item>
                    <div v-if="form.type === 'subjectivity'">
                        <el-form-item label="脚本代码：" label-width="114px" v-if="form.review_mode === 'script'">
                            <div v-html="form.review_script" class="ql-editor" style="max-height: 300px; overflow-y: auto; margin-bottom: 10px"></div>
                        </el-form-item>
                        <el-form-item label="实操环境：" label-width="114px">
                            <span>{{ form.training_label }}</span>
                        </el-form-item>
                        <el-form-item label="答题方式：" label-width="114px">
                            <span v-if="form.submit_mode && form.submit_mode.length">{{ submitModeFormatter(form.submit_mode) }}</span>
                            <span v-if="form.submit_mode && form.submit_mode.length <= 0 && form.review_mode === 'script'">实操</span>
                        </el-form-item>
                    </div>

                    <el-form-item label="难度：" label-width="114px">{{form.difficulty_label}}</el-form-item>
                    <el-form-item label="标签：" label-width="114px">
                        <el-tag v-for="item in form.tags" :key="item.id" style="margin-right:10px">{{item.name}}</el-tag>
                    </el-form-item>
                    <el-form-item label="答案：" label-width="114px">
                        <span v-if="form.type == 'fill'">
                            <span v-for="(an,a) in form.answer" :key="a" style="margin-right:15px">{{an.join(' 或 ')+(a==form.answer.length-1?'':'； ')}}</span>
                        </span>
                        <div v-else-if="form.type == 'subjectivity'" v-html="form.answer[0]" class="ql-editor" style="max-height: 300px; overflow-y: auto; margin-bottom: 10px"></div>
                        <span v-else>{{change(form.answer,form.type)}}</span>
                        <el-tag v-if="form.attachment.answer" size="medium" style="margin-bottom:10px"><a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.answer.file_path,form.attachment.answer.file_name)" target="_blank"><i class="el-icon-download"></i> 答案附件 {{form.attachment.answer.file_name}}</a></el-tag>
                    </el-form-item>
                    <el-form-item label="解析：" label-width="114px">
                        <div v-html="form.analysis" class="ql-editor"></div>
                        <el-tag v-if="form.attachment.analysis" size="medium" style="margin-bottom:10px"><a :href="config_env.BASE_URL+getDownloadAddress(form.attachment.analysis.file_path,form.attachment.analysis.file_name)" target="_blank"><i class="el-icon-download"></i> 解析附件 {{form.attachment.analysis.file_name}}</a></el-tag>
                    </el-form-item>
                    <el-form-item label-width="60px" style="margin:15px 0">
                        <el-button type="primary" @click="$router.push({ name: 'questionEdit', query: { editId: form.id, type: form.type, parentId: $route.query.parentId }})">编辑</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import quillEditor from '@/components/editor/index.vue'
import { getDownloadAddress } from '@/utils/common.js'
export default {
    components: {
        quillEditor
    },
    data() {
        return {
            typeList: [ '单选题', '多选题', '不定项', '判断题', '填空题', '主观题' ],
            letter: ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
            form: {
                id: null,
                type: null,
                type_label:'',
                attachment:{},
                crosshead: [],
                choices:[],
                stem: '',
                answer:null,
                difficulty:'1',
                score: 2,
                ischeck: false,
                tag:null,
                submit_mode: []
            },
            answer: null,
            num: 0,
            text: [''],
            props: { multiple: true, expandTrigger: 'hover' },
            options: [{
                value: 1,
                label: '东南',
                children: [{
                    value: 2,
                    label: '上海',
                    children: [
                    { value: 3, label: '普陀' },
                    { value: 4, label: '黄埔' },
                    { value: 5, label: '徐汇' }
                    ]
                }, {
                    value: 7,
                    label: '江苏',
                    children: [
                    { value: 8, label: '南京' },
                    { value: 9, label: '苏州' },
                    { value: 10, label: '无锡' },
                    { value: 18, label: '南京' },
                    { value: 19, label: '苏州' },
                    { value: 110, label: '无锡' }
                    ]
            }]}],
            row: null
        }
    },
    computed: {
        reviewModeOptions() {
            return this.$store.state.question.reviewModeOptions
        },
        submitModeOptions() {
            return this.$store.state.question.submitModeOptions
        }
    },
    methods: {
        getDownloadAddress,
        change(answer,type) {
            if (type == 'single_choice') {
                return this.letter[answer]
            }else if (type == 'choice' || type == 'uncertain_choice') {
                let arr = []
                for (let i = 0; i < answer.length; i++) {
                    const j = answer[i]
                    arr.push(this.letter[j])
                }
                return arr.join('、')
            }else if(type == 'determine') {
                if (answer[0] == 0) {
                    return '错误'
                } else {
                    return '正确'
                }
            }
        },
        checkboxChange(val) {
            return val.sort()
        },
        reset() {
            this.$refs['form'].resetFields();
        },
        edit(row) {
            this.row = row
            this.editDialogVisible = true
        },
        delet(row) {
            this.$confirm('确定要删除该题目?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '删除成功'
                });
            }).catch(() => {});
        },
        close(data) {
            this.editDialogVisible = data
            this.importDialogVisible = data
            this.difficultyDialogVisible = false
            this.scoreDialogVisible = false
        },
        seeShare(e){
            let name = localStorage.getItem("1+XUserIdentity");
            this.$store.dispatch("getTrainingInstanceSrc",e.training_id).then(res => {
                if (res.status == 200) {
                    let routeUrl = this.$router.resolve({
                        path: "/practicalTraining",
                        query: {
                          name,
                          exam: null,
                          trainingMirror: e.training_id,
                          questionId: e.id,
                          reviewMode: e.review_mode,
                          isVerifyMode: true,
                        },
                    });
                    window.open(routeUrl.href, '_blank');
                }
            })


        },
        reviewModeFormatter(reviewMode) {
            let already = this.reviewModeOptions.find(item => item.dict_value === reviewMode)
            return already ? already.dict_label : ''
        },
        submitModeFormatter(submitModeList) {
            let ret = [];
            submitModeList.forEach(submitMode => {
                let already = this.submitModeOptions.find(item => item.dict_value == submitMode)
                if (already) {
                    ret.push(already.dict_label)
                }
            })
            return ret.join('、')
        }
    },
    created() {
        this.form.id = this.$route.query.id
        this.$store.dispatch("getQuestionPreview", this.form.id).then(res => {
            // if (res.data.choices) {
            //     res.data.choices = JSON.parse(res.data.choices)
            // }
            // res.data.answer = JSON.parse(res.data.answer)
            let form = res.data
            if (!form.attachment) {
                form.attachment = {}
            }
            if (form.type == 'choice' || form.type == 'uncertain_choice' || form.type == 'single_choice' || form.type == 'determine') {
                if (form.type == 'single_choice' || form.type == 'determine') {
                    form.choose = null
                    this.answer = form.type == 'single_choice'?this.letter[form.answer[0]]:form.answer
                }else {
                    if (form.type == 'choice' || form.type == 'uncertain_choice') {
                        this.answer = this.change(form.answer)
                    }
                    form.choose = []
                }
            }else if (form.type == 'fill') {
                for (let i = 0; i < form.answer.length; i++) {
                    let str = '______('+(i+1)+')______'
                    form.stem = form.stem.replace(/\[\[(.*?)\]\]/,str)
                }
                form.stemPreview = form.stem
            }else if (form.type == 'subjectivity') {
                if (form.crosshead.length) {
                    // form.crosshead = JSON.parse(res.data.crosshead)
                    for (let l = 0; l < form.crosshead.length; l++) {
                        const f = form.crosshead[l]
                        let str = f.stem
                        if (str.indexOf('</p>') != -1) {
                            f.stem = str.slice(0, -4) + `<span class="el-tag el-tag--info el-tag--mini">${f.score}分</span></p>`
                        }else {
                            f.stem = str + `<span class="el-tag el-tag--info el-tag--mini">${f.score}分</span>`
                        }
                    }
                }

            }
            this.form = form
        });
    },
}
</script>

<style scoped>
    .info {
        color: #C0C4CC;
        font-size: 14px;
        line-height: 20px;
        margin-top: 6px;
    }
    .editor {
        width: calc(100% - 60px);
    }
    .editor100p {
        width: 100%;
    }
    .el-radio-group {
        display: block;
    }
    .el-row .el-button {
        margin-left: 15px;
        height: 42px;
    }
    .el-form-item--small.el-form-item {
        margin-bottom: 0 !important;
    }
    .el-form >>> .el-tag--mini {
        font-size: 13px !important;
        margin-left: 10px;
        line-height: 18px;
    }
</style>
